<template lang="pug">
.leftNav
  el-radio-group(style="margin-bottom: 10px;" v-if="!isLowcode" v-model="userNav", size="mini", @change="changeUserType")
    el-radio-button(v-for="item in typeList", :key="item.id", :label="item.id") {{ item.cnName }}
  //- 左侧搜索加列表
  el-input.keyword(v-model.trim="filterText", placeholder="请输入姓名/账号/公司/手机号", size="small", prefix-icon="el-icon-search", clearable)
  //- 树形结构选择框
  el-tree.filter-tree( v-show="!filterText", ref="tree", node-key="nodeId", :expand-on-click-node="false", :data="treeData", :props="defaultProps"
    @check-change="handleCheckChangeParent", show-checkbox, highlight-current, v-slot="{ node, data }" )
    node-icon(:node="node", :type="userFrom") {{ data.nodeName }}
  .searchForBox(v-show="filterText")
    .searchTitle 人员
    el-tree.people-tree( ref="tree1", node-key="nodeId", show-checkbox, highlight-current, :data="peopleList",
      :expand-on-click-node="false", :props="defaultPropsSearchFor", @check-change="handleCheckChangeFilter",
      v-slot="{ node, data }" )
      .treeContent
        .name {{ data.nodeName }}
        .labels(:title="data.fullDeptName") {{ data.fullDeptName }}
    .searchTitle 公司
    el-tree.people-tree( ref="tree2", node-key="nodeId", show-checkbox, highlight-current, :data="depList",
      :expand-on-click-node="false", :props="defaultPropsSearchFor", @check-change="handleCheckChangeFilter",
      v-slot="{ node, data }" )
      .treeContent
        .name {{ data.nodeName }}
        .labels(:title="data.fullDeptName", v-if="data.type === 3") {{ data.fullDeptName }}
  </template>

<script>
/** *
 * 本组件采用新的树形结构用于选人，不同于element，慎用
 * ***/
import { mapState } from "vuex";
import ElTree from "@/CommonDP/lib/tree/src/tree.vue";
import flowService from "@/CommonDP/service/flow-service";
import NodeIcon from "@/CommonDP/components/chooseMember/component/NodeIcon.vue";

export default {
  components: { ElTree, NodeIcon },
  props: {
    isLowcode: { type: Boolean, default: false },
    type: { type: Number, default: 1 },
    // 是否过滤当前用户 ,默认为false
    filterOneself: { type: Boolean, default: false },
    // 选中的人员组件
    userList: { type: Array, default: () => [] },
    // 当前部门
    curDeptId: { type: String, default: "" },
    // 部门
    deptId: { type: String, default: "" },
    // 项目id
    prjId: { type: String, default: "" },
    // 项目角色code
    prjRoleId: { type: String, default: "" },
    // 专业角色code
    specRoleId: { type: String, default: "" },
    // 系统角色code
    sysRoleId: { type: String, default: "" },
    // 标签角色code
    labelRole: { type: String, default: "" },
  },
  data() {
    return {
      filterText: "",
      defaultProps: {
        children: "children",
        label: "nodeName",
      },
      defaultPropsSearchFor: {
        children: "children",
        label: "deptName",
      },
      peopleData: [], // 人员数据
      peopleList: [], // 搜索的人员
      depList: [], // 搜索的部门
      nowSelect: [],
      userNav: "cur_dept",
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo,
      prjInfo: (state) => state.projectMg.prjObj,
    }),
    // 1根据组织架构搜索 2根据系统角色搜索 3指定部门搜索 4当前用户部门搜索 5根据专业角色搜索 6根据当前项目搜索 7根据指定标签搜索 8系统角色查询所有及人员 9专业角色查询所有及人员 10系统标签查询所有及人员
    typeList() {
      const list = [
        { id: "cur_dept", cnName: "本部门" },
        { id: "prj", cnName: "当前项目" },
        { id: "all", cnName: "组织架构" },
        { id: "role", cnName: "系统角色" },
        { id: "specRole", cnName: "专业角色" },
        // { id: "tag", cnName: "标签" },
      ];
      if (!this.prjId) {
        return list.filter((item) => item.id !== "prj" && item.id !== "specRole");
      } else {
        return list;
      }
    },
    treeData() {
      return !this.filterOneself ? this.peopleData : this.filterUser(this.peopleData);
    },
    defaultCheckedKeys() {
      return this.nowSelect?.map(({ deptId }) => deptId) || [];
    },
    // 1根据组织架构搜索 2根据系统角色搜索 3指定部门搜索 4当前用户部门搜索 5根据专业角色搜索 6根据当前项目搜索 7根据指定标签搜索 8系统角色查询所有及人员 9专业角色查询所有及人员 10系统标签查询所有及人员
    userType() {
      if (this.isLowcode) {
        return this.type;
      } else {
        switch (this.userNav) {
          case "cur_dept":
            return 4;
          case "prj":
            return 6;
          case "all":
            return 1;
          case "role":
            return 8;
          case "specRole":
            return 9;
          case "tag":
            return 10;
          default:
            return 1;
        }
      }
    },
    getNewParams() {
      const curDeptId = this.userNav === "cur_dept" ? "cur" : this.curDeptId;
      const prjId = this.userNav === "prj" ||this.type === 6? this.prjId || this.prjInfo.prjId : "";
      const isSysRoleAll = this.userNav === "role" ? 1 : "";
      const isSpecRoleAll = this.userNav === "specRole" ? 1 : "";
      const isLabelAll = this.userNav === "tag" ? 1 : "";
      return {
        userType: this.userType,
        enterpriseId: this.enterpriseId,
        deptId: this.deptId,
        sysRoleId: this.sysRoleId,
        prjId,
        specRoleId: this.specRoleId,
        curDeptId,
        isSysRoleAll,
        isSpecRoleAll,
        isLabelAll,
        prjRoleId: this.prjRoleId,
        keyword: this.filterText,
      };
    },
    getOrgListKeyWordParams() {
      const curDeptId = this.userNav === "cur_dept" && !this.isLowcode ? "cur" : this.curDeptId; // "2095822793867264"
      const prjId = this.userNav === "prj" && !this.isLowcode ? this.prjId || this.prjInfo.prjId : this.prjId;
      const isSysRoleAll = this.userNav === "role" ? 1 : "";
      const isSpecRoleAll = this.userNav === "specRole" ? 1 : "";
      const isLabelAll = this.userNav === "tag" ? 1 : "";
      return {
        userType: this.userType,
        enterpriseId: this.enterpriseId,
        keyword: this.filterText,
        deptId: this.deptId,
        curDeptId,
        prjId,
        isSysRoleAll,
        isSpecRoleAll,
        isLabelAll,
        prjRoleId: this.prjRoleId,
        specRoleId: this.specRoleId,
        sysRoleId: this.sysRoleId,
      };
    },
    userFrom() {
      if (this.prjId && !this.specRoleId) {
        return "User.project";
      } else if (this.prjRoleId) {
        return "User.prjRole";
      } else if (this.specRoleId) {
        return "User.specRole";
      } else if (this.sysRoleId) {
        return "User.sysRole";
      } else if (this.deptId || this.curDeptId) {
        return "User.dept";
      } else {
        return "User";
      }
    },
  },
  watch: {
    filterText(val) {
      if (val) {
        this.getOrgKeywordList(val);
      }
    },
    userList: {
      immediate: true,
      async handler(val) {
        this.nowSelect = val;
      },
    },
  },
  mounted() {
    this.getOrgList();
  },
  methods: {
    // 部门人员
    async getOrgList() {
      const res = await flowService.queryOrgListNewMember(this.getNewParams);
      this.peopleData = res.data;
      if (this.nowSelect.length > 0) {
        await this.$nextTick();
        this.$refs.tree && this.setCheck(this.nowSelect, this.$refs.tree);
      }
    },
    // 搜索时展示数据
    async getOrgKeywordList(val) {
      this.peopleList = [];
      this.depList = [];
      const { data } = await flowService.queryOrgListNewMemberByKeyword(this.getNewParams);
      this.peopleList = data?.userList || [];
      this.depList = data?.deptList || [];
      if (this.nowSelect.length > 0) {
        await this.$nextTick();
        this.setCheck(this.nowSelect, this.$refs.tree1);
        this.setCheck(this.nowSelect, this.$refs.tree2);
      }
    },
    // 设置默认选中
    setCheck(list, dom) {
      if (list && list.length) {
        list.forEach((item) => {
          this.myFilter(item.nodeId, dom);
        });
      }
    },
    // 因为我这里初始默认选中的数据结构和 部门列表的数据结构不一致,所以我进行了多一层处理
    // 将初始默认选中的数据传入进行过滤,将过滤成功的数据进行勾选并渲染
    myFilter(value, dom) {
      // const _this = this;
      const traverse = function (node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach((child) => {
          if (child.data.nodeId === value) {
            dom.setMyChecked(child.data, true, true);
          }
          traverse(child);
        });
      };
      traverse(dom);
    },

    // 设置选择框状态
    handleCheckChangeParent(data, checked) {
      // 改造的树形结构设置实现绑定的node-key相同的选择
      data.nodeId && this.$refs.tree.setMyChecked && this.$refs.tree.setMyChecked(data, checked, true);
      // 右边渲染列表
      const workDeptIds = this.$refs.tree.getCheckedNodes().filter((item) => item.nodeId && item.nodeType === "user"); // nodeType:user人员 dept部门
      this.nowSelect = this.unique(workDeptIds);
      this.emitList();
    },
    // 搜索的人员和部门 选中状态
    handleCheckChangeFilter(data, checked) {
      data.nodeId && this.$refs.tree1.setMyChecked && this.$refs.tree1.setMyChecked(data, checked, true);
      data.nodeId && this.$refs.tree2.setMyChecked && this.$refs.tree2.setMyChecked(data, checked, true);
      data.nodeId && this.$refs.tree.setMyChecked && this.$refs.tree.setMyChecked(data, checked, true);
      const workDeptIds = this.$refs.tree1.getCheckedNodes().filter((item) => item.nodeId && item.nodeType === "user"); // nodeType:user人员 dept部门
      const workDeptIds2 = this.$refs.tree2.getCheckedNodes().filter((item) => item.nodeId && item.nodeType === "user");
      const list = this.unique(workDeptIds);
      const list2 = this.unique(workDeptIds2);
      this.nowSelect = this.unique([...this.nowSelect, ...list, ...list2]);
      this.emitList();
    },
    // 取消选中的角色
    cancel(data) {
      this.$refs.tree.setMyChecked && this.$refs.tree.setMyChecked(data, false, true);
      this.$refs.tree1.setMyChecked && this.$refs.tree1.setMyChecked(data, false, true);
      this.$refs.tree2.setMyChecked && this.$refs.tree2.setMyChecked(data, false, true);
    },
    // async clearAll() {
    //   this.$refs.tree.setCheckedKeys([]);
    //   await this.$nextTick();
    //   this.$refs.tree.setMyChecked && this.$refs.tree.setMyChecked([], false, true);
    // },
    // 给父级抛出选中的人员
    emitList() {
      const list = this.nowSelect.map((e) => {
        return {
          id: e.nodeId,
          userId: e.nodeId,
          selectName: e.nodeName,
          name: e.userDisplayName,
          ...e,
          type: 0, // 此字段必须存在：指定为人时
        };
      });
      this.$emit("updateRight", "User", list);
    },
    // 去重
    unique(arr) {
      const res = new Map();
      return arr.filter((a) => !res.has(a.nodeName) && res.set(a.nodeName, 1));
    },
    // 过滤当前用户
    filterUser(data) {
      data = data.filter((item) => item.remark !== this.userInfo.name);
      data.forEach((item) => {
        if (item.children) {
          item.children = this.filterUser(item.children);
        }
      });
      return data;
    },
    changeUserType() {
      this.filterText = "";
      this.getOrgList();
    },
  },
};
</script>

<style lang="scss" scoped>
.leftNav {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.keyword {
  margin-bottom: 5px;
}
.el-tree {
  overflow-y: auto;
}
.people-tree {
  /deep/.el-tree-node__content {
    height: 100% !important;
    margin-bottom: 6px !important;
    align-items: start !important;
    padding-right: 5px !important;
  }
  .treeContent {
    display: flex;
    align-items: flex-start;
    width: 100%;
    overflow: hidden;
    padding-right: 5px;
    flex-direction: column;
    .name {
      line-height: 23px;
      margin-bottom: 5px;
      padding-left: 7px;
    }
    .labels {
      width: 100%;
      overflow: hidden;
      font-size: 12px;
      width: 100%;
      line-height: 30px;
      white-space: pre-wrap;
      word-wrap: break-word;
      background: #f4f4f4;
      border-radius: 5px;
      padding-left: 14px;
    }
  }
}
.searchForBox {
  overflow-y: auto;
}
.searchTitle {
  height: 30px;
  line-height: 30px;
  background: rgba(238, 243, 255, 0.88);
  color: var(--theme-color);
  padding-left: 16px;
  font-size: 14px;
}
</style>
